import Swiper from 'swiper';
import {
  Navigation,
  Pagination,
  Scrollbar,
  Grid,
  Autoplay,
} from 'swiper/modules';
import '../plugins/ResponsiveHelper';

export default function initSwiper() {
  function destroyGallery(inst) {
    if (inst) {
      inst.destroy();
    }
  }

  // eslint-disable-next-line no-undef
  jQuery('.swiper-intro').each((i, gallery) => {
    // eslint-disable-next-line no-undef
    const autoplay = jQuery(gallery).hasClass('has-autoplay');
    const opts = {
      modules: [Pagination],
      slidesPerView: 1,
      spaceBetween: 0,
      allowTouchMove: true,
      grabCursor: true,
      effect: 'fade',
      speed: 800,
      loop: true,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
        clickable: true,
      },
    };
    if (autoplay) {
      opts.modules.push(Autoplay);
      opts.autoplay = {
        delay: 5000,
      };
    }
    // eslint-disable-next-line no-new
    new Swiper(gallery, opts);
  });

  // eslint-disable-next-line no-undef
  jQuery('.gallery').each((i, gallery) => {
    // eslint-disable-next-line no-new
    new Swiper(gallery.querySelector('.swiper-carousel'), {
      modules: [Pagination, Navigation, Scrollbar],
      pagination: {
        el: '.swiper-pagination',
        type: 'fraction',
      },
      breakpoints: {
        0: {
          slidesPerView: 'auto',
          loop: false,
        },
        1025: {
          slidesPerView: 1,
          loop: true,
        },
      },
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
        hide: false,
      },
      navigation: {
        nextEl: gallery.querySelector('.swiper-button-next'),
        prevEl: gallery.querySelector('.swiper-button-prev'),
      },
    });
  });

  // eslint-disable-next-line no-undef
  jQuery('.swiper-news, .swiper-events, .swiper-downloads').each((i, gallery) => {
    let swiperInst = null;

    // eslint-disable-next-line no-undef
    ResponsiveHelper.addRange({
      '..1024': {
        on() {
          swiperInst = new Swiper(gallery, {
            grabCursor: true,
            allowTouchMove: true,
            slidesPerView: 'auto',
          });
        },
        off() {
          destroyGallery(swiperInst);
        },
      },
    });
  });

  // eslint-disable-next-line no-undef
  jQuery('.swiper-services-wrap').each((index, wrap) => {
    const gallery = wrap.querySelector('.swiper-services');
    const nextEl = wrap.querySelector('.swiper-button-next');
    const prevEl = wrap.querySelector('.swiper-button-prev');
    const scrollbar = wrap.querySelector('.swiper-scrollbar');
    const isWide = wrap.classList.contains('wide');

    if (!gallery) return;

    // eslint-disable-next-line no-new
    new Swiper(gallery, {
      modules: [Navigation, Scrollbar],
      threshold: 30,
      touchAngle: 30,
      loop: false,
      slidesPerView: 'auto',
      navigation: {
        nextEl,
        prevEl,
      },
      scrollbar: {
        el: scrollbar,
        draggable: true,
        hide: false,
      },
      breakpoints: {
        768: {
          slidesPerView: isWide ? 'auto' : 3,
        },
        1025: {
          slidesPerView: isWide ? 'auto' : 3,
        },
      },
    });
  });

  // eslint-disable-next-line no-undef
  jQuery('.product-visual').each((i, wrap) => {
    const gallery = wrap.querySelector('.swiper-product-visual');
    const thumbs = wrap.querySelectorAll('.product-thumbs .thumb');
    let swiperInst = null;

    if (!gallery) return;

    swiperInst = new Swiper(gallery, {
      spaceBetween: 0,
      threshold: 30,
      touchAngle: 30,
      loop: false,
      on: {
        slideChange: (swiper) => {
          thumbs.forEach((element) => {
            element.classList.remove('active-thumb');
          });
          thumbs[swiper.realIndex].classList.add('active-thumb');
        },
      },
    });

    thumbs.forEach((element, index) => {
      element.addEventListener('click', (e) => {
        e.preventDefault();

        if (swiperInst) {
          swiperInst.slideTo(index);
        }
      });
    });
  });

  // eslint-disable-next-line no-undef
  jQuery('.swiper-related-products').each((i, gallery) => {
    // eslint-disable-next-line no-new
    new Swiper(gallery, {
      modules: [Scrollbar, Grid, Navigation],
      grabCursor: true,
      allowTouchMove: true,
      scrollbar: {
        el: '.swiper-scrollbar',
        draggable: true,
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        0: {
          slidesPerView: 'auto',
          grid: false,
          spaceBetween: 12,
        },
        1025: {
          slidesPerView: 1,
          spaceBetween: 0,
          grid: {
            rows: 2,
            fill: 'column',
          },
        },
        1440: {
          slidesPerView: 2,
          grid: {
            rows: 2,
            fill: 'column',
          },
        },
      },
    });
  });
}
